import apiClient from '../../shared/services/apiClient';

const API_BASE = '/api/admin';

const quotaService = {
    // 获取配额信息（可按产品类型过滤）
    async getQuotas(productType) {
        const params = productType ? { product_type: productType } : {};
        const response = await apiClient.get(`${API_BASE}/quotas`, { params });
        return response.data;
    },

    // 按真实资源数量重算指定用户 + 产品类型的使用量
    async recalculate(userId, productType) {
        const response = await apiClient.post(`${API_BASE}/quotas/recalculate`, {
            user_id: userId,
            product_type: productType,
        });
        return response.data;
    },
};

export default quotaService;
